"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var expressionItenStyles_1 = require("./expressionItenStyles");
var ExpressionItem = function (_a) {
    var expressionData = _a.expressionData, id = _a.id;
    var _b;
    var styles = expressionItenStyles_1.default();
    return (<core_1.Grid item={true} className={styles.container} data-test={"summary:car_details:EOI_element:" + id}>
      <core_1.Typography variant="subtitle1">{(_b = expressionData) === null || _b === void 0 ? void 0 : _b.label}</core_1.Typography>
    </core_1.Grid>);
};
exports.default = ExpressionItem;
